export enum TrackCommentSourceEnum {
  lead = "lead",
  track = "track",
  respondIO = "respondIO",
  trackFollowUp = "trackFollowUp",
}

export type TrackUpdateType =
  | "comment"
  | "status_update"
  | "assignment_update"
  | "broker_showing";

export type TrackCommentUpdates = {
  id: number;
  uid: string;
  type: "comment";
  createdAt: string;
  commentSource?: TrackCommentSourceEnum;
  addedBy: { id: number; name: string; color?: string } | undefined;
  data: { comment: string };
};

export type TrackStatusUpdates = {
  id: number;
  type: "status_update";
  createdAt: string;
  addedBy?: { id: number; name: string; color?: string };
  comment?: string;
  data: {
    oldStatus?: { id: number; name: string; color?: string };
    newStatus?: { id: number; name: string; color?: string };
    oldStage?: { id: number; name: string; precedence: number; color?: string };
    newStage?: { id: number; name: string; precedence: number; color?: string };
  };
};

export type TrackAssignmentUpdates = {
  id: number;
  type: "assignment_update";
  createdAt: string;
  addedBy?: { id: number; name: string; color?: string };
  comment?: string;
  data: {
    oldUser: { id: number; name: string; color?: string } | null;
    newUser: { id: number; name: string; color?: string } | null;
  };
};

export type Broker = {
  id: number;
  uid: string;
  name: string;
};

export type TrackBrokerShowingUpdates = {
  id: number;
  uid: string;
  type: "broker_showing";
  createdAt: string;
  addedBy?: { id: number; name: string; color?: string };
  data: {
    brokerName: string | null;
    brokerUid: string | null;
    showingDate: string;
    tenantName: string;
  };
};

export type TrackUpdates =
  | TrackCommentUpdates
  | TrackStatusUpdates
  | TrackAssignmentUpdates
  | TrackBrokerShowingUpdates;

export type TrackUpdateDto = {
  data: TrackUpdates[];
  nextCursor: string | null;
  nextCursorId: number | null;
  lastCursorType: TrackUpdateType | null;
};
